import { Cpu, Mic, Thermometer, Phone, MessageSquare, Unlock, Globe, Languages, Timer, Bell, Images } from 'lucide-react';
import { BulkUpdateTemplate, BulkUpdateTemplateGroup } from '@/types/agent/bulk-update';
import { SHOW_RELATED_MEDIA_TOOL_ID } from '@/utils/config/elevenlabs';

export const SILENCE_TIMEOUT_TEMPLATE_ID = 'raise-silence-timeout';
export const PHONE_GOALS_TEMPLATE_ID = 'turn-on-phone-goals';

export const BULK_UPDATE_TEMPLATE_GROUPS: BulkUpdateTemplateGroup[] = ['Identity', 'Messaging', 'Tools', 'AI Config', 'Extra'];

export const BULK_UPDATE_TEMPLATES: BulkUpdateTemplate[] = [
  {
    id: SILENCE_TIMEOUT_TEMPLATE_ID,
    name: 'Raise Silence Timeout',
    description: 'Raise Silence End Call to the 5 minute standard',
    group: 'AI Config',
    icon: Timer,
    updates: {},
  },
  {
    id: 'change-llm',
    name: 'Change LLM Model',
    description: 'Update the language model for all selected agents',
    group: 'AI Config',
    icon: Cpu,
    updates: {
      settings: {
        conversation_config: {
          agent: {
            prompt: {
              llm: '',
            },
          },
        },
      },
    },
  },
  {
    id: 'change-report-mode',
    name: 'Change Report Mode',
    description: 'Update how conversation reports are sent for all selected agents',
    group: 'Messaging',
    icon: Bell,
    updates: {
      report_mode: 'off',
    },
  },
  {
    id: 'change-voice',
    name: 'Change Voice',
    description: 'Update the voice ID for all selected agents',
    group: 'Identity',
    icon: Mic,
    updates: {
      settings: {
        conversation_config: {
          tts: {
            voice_id: '',
          },
        },
      },
    },
  },
  {
    id: 'allow-all-overrides',
    name: 'Allow All Overrides',
    description: 'Enable ElevenLabs Security overrides: prompt, LLM, first message, language and text-only mode',
    group: 'Extra',
    icon: Unlock,
    updates: {
      settings: {
        platform_settings: {
          overrides: {
            conversation_config_override: {
              agent: {
                prompt: {
                  llm: true,
                  prompt: true,
                },
                language: true,
                first_message: true,
              },
              conversation: {
                text_only: true,
              },
            },
          },
        },
      },
    },
  },
  {
    id: 'enable-text-only',
    name: 'Enable Text-Only Mode',
    description: 'Switch agents to text-only conversation mode',
    group: 'AI Config',
    icon: MessageSquare,
    updates: {
      settings: {
        platform_settings: {
          overrides: {
            conversation_config_override: {
              conversation: {
                text_only: true,
              },
              agent: {
                first_message: true,
              },
            },
          },
        },
      },
    },
  },
  {
    id: 'enable-multilingual',
    name: 'Enable Multilingual Support',
    description: 'Support all languages available for the agent\'s TTS model',
    group: 'Identity',
    icon: Globe,
    updates: {
      isMultilingual: true,
    },
  },
  {
    id: 'enable-english-only',
    name: 'Enable English Only',
    description: 'Speak English only, using the faster English TTS model',
    group: 'Identity',
    icon: Languages,
    updates: {
      isMultilingual: false,
    },
  },
  {
    id: 'update-call-limit',
    name: 'Set Call Limits',
    description: 'Configure daily call limits for all selected agents',
    group: 'Extra',
    icon: Phone,
    updates: {
      settings: {
        platform_settings: {
          call_limits: {
            daily_limit: 100,
          },
        },
      },
    },
  },
  {
    id: 'set-max-duration',
    name: 'Set Max Duration',
    description: 'Set the maximum conversation duration in seconds',
    group: 'AI Config',
    icon: Timer,
    updates: {
      settings: {
        conversation_config: {
          conversation: {
            max_duration_seconds: 1800,
          },
        },
      },
    },
  },
  {
    id: 'change-temperature',
    name: 'Update Temperature',
    description: 'Adjust model creativity level for all selected agents',
    group: 'AI Config',
    icon: Thermometer,
    updates: {
      settings: {
        conversation_config: {
          agent: {
            prompt: {
              temperature: 0.7,
            },
          },
        },
      },
    },
  },
  {
    id: 'attach-related-media-tool',
    name: 'Attach Links & Images Tool',
    description: 'Let selected agents show relevant links and pictures in the chat',
    group: 'Tools',
    icon: Images,
    updates: {
      add_tool_ids: [SHOW_RELATED_MEDIA_TOOL_ID],
    },
  },
  {
    id: PHONE_GOALS_TEMPLATE_ID,
    name: 'Turn On Phone Insights (Goals)',
    description: "Add each genie's conversation goals to inbound phone calls from the start",
    group: 'Tools',
    icon: Phone,
    updates: {},
  },
];
